<template>
  <div class="container-fluid">
    <h2>Lieferschein</h2>
    <br/>
    <div class="row mt-3">
      <div class="col-md">
        <Address title="Kunde" :address="customer.data"/>
      </div>
      <div class="col-md">
        <Address title="Lieferanschrift" :address="note.address"/>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-header">Lieferschein</div>
          <div class="card-body">
            <div class="row">
              <div class="col"><b id="nrtitle">Lieferschein-Nr.:</b></div>
              <div class="col">{{ note.map_id }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Auftrags-Nr:</b></div>
              <div class="col">{{ note.order }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Kunden-Nr.</b></div>
              <div class="col"><a href="#" @click="openCustomer()">{{ customer.map_id }}</a></div>
            </div>
            <div class="row">
              <div class="col"><b>Erstellt:</b></div>
              <div class="col">{{ note.created }}</div>
            </div>
            <div class="row">
              <div class="col"><b>Lieferung:</b></div>
              <div class="col">{{ note.deliverdate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4>Positionen:</h4>
    <b-table :items="note.positions" :fields="fields" @row-clicked="openArticle" striped hover>
    </b-table>
    <hr/>
    <div class="row">
      <div class="col-md">
        <h5>Kommentar:</h5><br/>
        <p>{{ note.comment }}</p>
      </div>
      <div v-if="note.extras" class="col-md">
        <h5>Parameter:</h5><br/>
        <table class="table table-striped">
            <tr v-for="(val,key) in note.extras" :key="key">
              <td valign="top"><b>{{ key }}</b></td>
              <td>
                <span>{{ val }}</span>
              </td>
            </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import delivernotes from '@/modules/delivernotes.js'
import customers from '@/modules/customers.js'
import Address from '@/components/documents/Address.vue'

export default {
  name: 'DeliveryNoteView',
  components: {
    Address
  },
  data() {
    return {
      customer: { data: {} },
      note: { positions: [] , address: {}},
      fields: [
        {"key":"pos","label":"Pos."},
        {"key":"article_nr","label":"Artikel"},
        {"key":"desc","label":"Beschreibung"},
        {"key":"count","label":"Menge"},
        {"key":"unit","label":"Einheit"}
      ],
    }
  },
  mounted() {
    var self = this;
    delivernotes.load(this.$route.params.noteid).then(function(data) {
      self.note = data;
      console.log('note',data);
      customers.load(self.note.customer,this,function(data) {
        console.log(data.value,self);
        self.customer.data = data.value;
        self.$forceUpdate();
      });
    });
  },
  methods: {
    openArticle: function(row) {
      router.push({name: 'ArticleView',params:{articleid: row.article_id }});
    },
    openCustomer: function() {
      if (this.customer.map_id) {
        router.push({name: 'CustomerView',params:{customerid: this.customer.map_id }});
      }
    },
  }
}
</script>
